import { Button, Drawer, Radio, Tag, Input, Switch, Checkbox, Select, Tooltip , Flex} from "antd";
import { useState, useRef, useEffect } from "react";
import { CustomEdge, CustomHandle } from "../handler/main";
import {
    Position,
    Handle,
    useReactFlow,
    MarkerType
} from '@xyflow/react';
import './main.css'

import { ThunderboltOutlined, PlusOutlined } from '@ant-design/icons';
import { GrMultiple } from "react-icons/gr";
import { TbHistoryToggle } from "react-icons/tb";
import { AiOutlineComment } from "react-icons/ai";
import { CiLocationArrow1 } from "react-icons/ci";
import callAPI from "../../../../comps/fetch/main";


function RenderPosts({ postList, SelectedList, SetSelected, setLoadMore, loading }) {
    console.log("-=POSTS LIST-=-", postList?.posts_lists?.data, SelectedList);

    if (loading || !postList?.posts_lists?.data) {
        return <p>Loading</p>;
    }
    if (postList.posts_lists.data.length < 1) {
        return <p>Looks like empty</p>;
    }

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)', // 3 images in a single row
            gap: '10px',
            overflowX: 'auto',
            scrollbarWidth: 'thin',
            maxHeight:"400px"
        }}>
            {postList.posts_lists.data.map((post, index) => {
                const isSelected = SelectedList.includes(post.id);
                return (
                    <div key={index} style={{ position: 'relative', minWidth: '140px' }}>
                        <Checkbox
                            checked={isSelected}
                            onChange={() => SetSelected(post)}
                            style={{
                                position: 'absolute',
                                top: '5px',
                                left: '5px',
                                zIndex: 2,

                                borderRadius: '4px',
                                padding: '2px'
                            }}
                        />
                        <img
                            alt={post.caption}
                            style={{ minWidth: '140px', maxWidth: '100%', border: isSelected ? '3px solid blue' : 'none' }}
                            className="thumbnil-img"
                            src= {`https://imagecorsworkers.sanjayhotaction.workers.dev/${post.thumbnail_url}`}
                            onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop if fallback also fails
                                e.target.src = post.thumbnail_url || post.media_url
                            }}
                            crossOrigin="anonymous"
                        />
                    </div>
                );
            })}
        </div>
    );
}

function RenderAds({ postList, SelectedList, SetSelected, setLoadMore, setAdsList, loading }){

    if (loading || !postList?.posts_lists?.data) {
        return <p>Loading</p>;
    }
    if (postList.posts_lists.data.length < 1) {
        return <p>Looks like empty</p>;
    }
    
     return(
          <div >
                      <Flex gap={10} className="hscroll" style={{marginBottom:"10px", overflowX:"scroll"}} >
    
                    {postList?.ad_acount_list?.data.map((adaccount, index) => (
                      <div
                        key={index}
                        onClick={() => {
                          localStorage.setItem("ad-account-id" , adaccount?.id)
                          setAdsList([])
                          setLoadMore(true)
                        }}
                        style={{
                          padding: "12px 16px",
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          backgroundColor: localStorage.getItem("ad-account-id") == adaccount?.id ? "#1677ff" :  "#fafafa",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                          cursor: "pointer"
                        }}
                      >
                        <div>
                          <div style={{ fontWeight: "600", fontSize: "16px", color: localStorage.getItem("ad-account-id") == adaccount?.id ? "white" : "#333" }}>
                            {adaccount?.name}
                          </div>
                          <div style={{ fontSize: "14px", color: localStorage.getItem("ad-account-id") == adaccount?.id ? "white" :  "#666" }}>
                            {adaccount?.business?.name || "No Business Linked"}
                          </div>
                        </div>
                      </div>
                    ))}
    
                        </Flex>
                      <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(1, 1fr)', // 3 images in a single row
                            gap: '10px',
                            overflowX: 'auto',
                            scrollbarWidth: 'thin',
                            maxHeight:"800px",
                            paddingTop:"20px"
                        }} >
                        {postList?.posts_lists?.data.map((post, index) => {
                        let ad_og_post_id = post?.creative?.source_instagram_media_id ? post?.creative?.source_instagram_media_id : post?.creative?.effective_instagram_media_id
                            const isSelected = SelectedList.includes(ad_og_post_id);
                            
                          if (!ad_og_post_id){
                            return null
                          }
    
                        //   post?.insights?.data?.length > 0 && console.log(post?.insights?.data[0].clicks)
                        //   if (filterPosts == true && dataAutomatedFormated[ad_og_post_id] != true){
                        //     return null
                        //   }
    
                          return (
                            <div key={index} onClick={() =>SetSelected({id : ad_og_post_id})} style={{ position: 'relative', minWidth: '140px' }}>
                        <Checkbox
                            checked={isSelected}
                            onChange={() => SetSelected({id : ad_og_post_id})}
                            style={{
                                position: 'absolute',
                                top: '5px',
                                left: '5px',
                                zIndex: 2,

                                borderRadius: '4px',
                                padding: '2px'
                            }}
                        />
                                
                                <Flex gap="middle"  justify="flex-start" align="center"  style={{ columnGap: "16px", rowGap: "12px", border:"1px solid rgba(189, 186, 186, 0.3)" }} >
    
                                <img alt={post.caption} style={{ minWidth: '140px', maxWidth: '100%' }} className="thumbnil-img" 
                                    
                                  src= {post?.creative?.image_url ? `https://imagecorsworkers.sanjayhotaction.workers.dev/${post?.creative?.image_url}` : post?.creative?.thumbnail_url ? `https://imagecorsworkers.sanjayhotaction.workers.dev/${post?.creative?.thumbnail_url}` : null}
                                  onError={(e) => {
                                    // e.target.onerror = null; // prevent infinite loop if fallback also fails
                                    // e.target.src = post?.creative?.image_url ? post?.creative?.image_url : post?.creative?.thumbnail_url
                                }}
                                 crossorigin="anonymous" />
    
                                  <Flex style={{padding:"10px", flex:1, width:"60%", maxWidth:"300px"}} vertical >
                                    <div style={{ fontSize:"16px"}}>
                                      </div>
                                    <p style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>
                                      Ad: {post?.name}
                                    </p>
                                    <p style={{ margin: 0, fontSize: 13, color: "#666" }}>
                                      Ad Set: {post?.adset?.name}
                                    </p>
                                    <p style={{ margin: 0, fontSize: 12, color: "#999" }}>
                                      Campaign: {post?.campaign?.name}
                                    </p>
                                    

                                  </Flex>
    
                                    
                                    
                                        
                                      
                                      
                                </Flex>
                            
                        </div>)
                        })}
                    </div>
                    </div>
    

     )               
    
                
}



export default function TriggerComp({ id, data }) {
    const { updateNodeData } = useReactFlow();
    const [showTriggerModal, setShowTriggerModal] = useState(false)
    const [tags, setTags] = useState([]);
    const [comments, setComments] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [commentValue, setCommentValue] = useState('');
    const [isAddingTag, setIsAddingTag] = useState(false);
    const [addingType, setAddingType] = useState('');
    const inputRef = useRef(null);
    const commentRef = useRef(null);


    const [loadingStories, setLoadingStories] = useState(false)
    const [loadMoreStories, setLoadMoreStories] = useState(false)
    const [storiesList, setStoriesList] = useState(undefined)
    const [oldStoriesList, setOldStoriesList] = useState(undefined)

    const [loadingPosts, setLoadingPosts] = useState(false)
    const [loadMorePosts, setLoadMorePosts] = useState(false)
    const [postList, setPostsList] = useState(undefined)
    const [oldPostsList, setOldPostsList] = useState(undefined)

    const [loadingAds, setLoadingAds] = useState(false)
    const [loadMoreAds, setLoadMoreAds] = useState(false)
    const [AdsList, setAdsList] = useState(undefined)
    const [oldAds, setoldAds] = useState(undefined)


    useEffect(() => {

        
        if (storiesList == undefined) {
            return
        }
        if (oldStoriesList != undefined && oldStoriesList != []) {

            let old_data = [...oldStoriesList]
            setOldStoriesList(undefined)

            let all_data = [...storiesList.posts_lists.data, ...old_data]
                .reduce((acc, item) => {
                    acc.set(item.id, item);
                    return acc;
                }, new Map()).values();

            all_data =  Array.from(all_data)

            console.log("-=-=-=all data-=-=-2", all_data)
            setStoriesList({
                ...storiesList,
                posts_lists: {
                    ...storiesList.posts_lists,
                    data: [...all_data]
                }
            })

        }
        // if(storiesList? != undefined){
        //     setStoriesList(storiesList.posts_lists)
        // }
    }, [storiesList])

    useEffect(() => {

        if (postList == undefined) {
            return
        }
        if (oldPostsList != undefined && oldPostsList != []) {

            let old_data = [...oldPostsList]
            setOldPostsList(undefined)

            let all_data = [...postList.posts_lists.data, ...old_data]
                .reduce((acc, item) => {
                    acc.set(item.id, item);
                    return acc;
                }, new Map()).values();

            all_data =  Array.from(all_data)

            
            setPostsList({
                ...postList,
                posts_lists: {
                    ...postList.posts_lists,
                    data: [...all_data]
                }
            })

        }

    }, [postList])

    useEffect(() => {

        if (AdsList == undefined) {
            return
        }
        if (oldAds != undefined && oldAds != []) {

            let old_data = [...oldAds]
            setoldAds(undefined)

            let all_data = [...AdsList.posts_lists.data, ...old_data]
                .reduce((acc, item) => {
                    acc.set(item.id, item);
                    return acc;
                }, new Map()).values();

            all_data =  Array.from(all_data)

            
            setAdsList({
                ...AdsList,
                posts_lists: {
                    ...AdsList.posts_lists,
                    data: [...all_data]
                }
            })

        }

    }, [AdsList])


    useEffect(() => {
        console.log("Story replies....",loadingStories , data?.auto_reply?.story_reply?.all_stories)
        if (loadingStories == true || data?.auto_reply?.story_reply?.all_stories == "true") {
            return
        }
        if (loadMoreStories == false) {
          return
        }

        let apiURL = ""

        apiURL = "ig-stories"
        // apiURL = "ig-posts"

        if (storiesList?.posts_lists?.paging?.cursors?.after) {
            apiURL += `?after=${storiesList?.posts_lists?.paging?.cursors?.after}`
            if (storiesList.posts_lists.data != undefined) {
                setOldStoriesList([...storiesList.posts_lists.data])
            }
        }
        callAPI({ url: apiURL, method: "GET", loadingState: setLoadMoreStories, dataState: setStoriesList })
        setLoadMoreStories(false)

    }, [loadMoreStories])

    useEffect(() => {
        if(data?.auto_reply?.story_reply?.all_stories != "true" && data?.auto_reply?.story_reply?.all_stories != true ){
            setLoadMoreStories(true)
        }
    },[data?.auto_reply?.story_reply?.all_stories])


    useEffect(() => {
        if(data?.auto_reply?.comment_reply?.all_posts != "true" && data?.auto_reply?.comment_reply?.all_posts != true ){
           data?.auto_reply?.comment_reply?.all_posts == "false-ads" ? setLoadMoreAds(true) :  setLoadMorePosts(true)
        }
    },[data?.auto_reply?.comment_reply?.all_posts])


    useEffect(() => {
        console.log("Calling POSTS API")

        if (loadingPosts == true){
            //  || data?.auto_reply?.comment_reply?.all_posts == "true") {
            return
        }
        if (loadMorePosts == false ) {
          return
        }

        let apiURL = ""

        // apiURL = "ig-stories"
        apiURL = "ig-posts"

        if (postList?.posts_lists?.paging?.cursors?.after) {
            apiURL += `?after=${postList?.posts_lists?.paging?.cursors?.after}`
            if (postList.posts_lists.data != undefined) {
                setOldPostsList([...postList.posts_lists.data])
            }

        }

        callAPI({ url: apiURL, method: "GET", loadingState: setLoadMorePosts, dataState: setPostsList })

        setLoadMorePosts(false)

    }, [loadMorePosts])

    useEffect(() => {
        function addQueryParam(url, key, value) {
            return url + (url.includes("?") ? "&" : "?") + `${key}=${value}`;
            }
        console.log("Calling ADs API")
        if (loadingAds == true){
            //  || data?.auto_reply?.comment_reply?.all_posts == "true") {
            return
        }
        if (loadMoreAds == false ) {
          return
        }

        let apiURL = ""

        // apiURL = "ig-stories"
        apiURL = "meta-ads"

        if (localStorage.getItem("ad-account-id")){
                console.log("Ads selected-=-=-=-=-=-" ,localStorage.getItem("ad-account-id") )
                apiURL = addQueryParam(apiURL,"adaccounts", localStorage.getItem("ad-account-id"));
                }

        if (AdsList?.posts_lists?.paging?.cursors?.after) {
                apiURL = addQueryParam(apiURL,"after", AdsList?.posts_lists?.paging?.cursors?.after);
        }
          if (AdsList?.posts_lists?.data != undefined) {
                setoldAds([...AdsList.posts_lists.data])
            }

        callAPI({ url: apiURL, method: "GET", loadingState: setLoadMoreAds, dataState: setAdsList })

        setLoadMoreAds(false)

    }, [loadMoreAds])


    // useEffect(() => {
    //     if (data?.auto_reply == undefined) {
    //         updateNodeData(id, { ...data, auto_reply: {} })
    //     }
        
    // }, [data])

    
    if(data?.auto_reply?.comment_reply == undefined){
        return 
    }


    const handleClose = (item, tag_type = "") => {

        let newItems = []
        if (tag_type === 'dm_reply') {
            newItems = data.auto_reply?.dm_reply?.triger_words.filter((tag) => tag !== item)
            updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, dm_reply:{...data.auto_reply?.dm_reply , triger_words: [...newItems] }} })
        } if (tag_type === 'story_reply') {
            newItems = data.auto_reply?.story_reply?.triger_words.filter((tag) => tag !== item)
            updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, story_reply:{...data.auto_reply?.story_reply , triger_words: [...newItems] }} })
        } if (tag_type === 'comment_reply') {
            newItems = data.auto_reply.comment_reply?.triger_words.filter((tag) => tag !== item)
            updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply:{...data.auto_reply.comment_reply , triger_words: [...newItems] }} })
        }
        if (tag_type === 'comment_response') {
            newItems = data.auto_reply.comment_reply.comment_response.filter((tag) => tag !== item)
            updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply:{...data.auto_reply.comment_reply , comment_response: [...newItems] }} })
        }
    };

    const handleInputChange = (e) => {
            setInputValue(e.target.value);
    };

    const handleInputConfirm = () => {
        const value = inputValue
        console.log(addingType, value)
        // const value = addingType === 'tag' ? inputValue : commentValue;
        // if (value && ![...tags, ...comments].includes(value)) {
            if (addingType === 'dm_reply') {
                updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, dm_reply:{...data.auto_reply?.dm_reply , triger_words: [...(data.auto_reply?.dm_reply?.triger_words || []), value] }} })
            } if (addingType === 'story_reply') {
                updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, story_reply:{...data.auto_reply?.story_reply , triger_words: [...(data.auto_reply?.story_reply?.triger_words || []), value] }} })
            } if (addingType === 'comment_reply') {
                updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply:{...data.auto_reply.comment_reply , triger_words: [...(data.auto_reply.comment_reply?.triger_words || []), value] }} })
            }
            if (addingType === 'comment_response') {
                updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply:{...data.auto_reply.comment_reply , comment_response: [...(data.auto_reply.comment_reply.comment_response || []), value] }} })
            }
        // }
        setIsAddingTag(false);
        setInputValue('');
        setCommentValue('');
    };



    const showInput = (type) => {
        setIsAddingTag(true);
        setAddingType(type);
    };

    const renderItem = (item, type) => (
        <span key={item} style={{ display: 'inline-block', marginBottom: '20px' }}>
            <Tag
                style={{ padding: '10px 10px', fontSize: '14px', gap: '10px' }}
                color="blue"
                closable
                onClose={(e) => {
                    e.preventDefault();
                    handleClose(item, type);
                }}
            >
                {item}
            </Tag>
        </span>
    );

    const tagChild = data.auto_reply?.triger_words?.map((tag) => renderItem(tag, 'tag'));



    return (
        <div className="flow-comp trigger-comp">
            <CustomHandle type="source" id={`${id}`} />
            <p className="comp-title">⚡Trigger</p>
            <div style={{display:"flex", flexDirection:"column", gap:"10px", marginTop:"10px"}}>
                {data.auto_reply?.dm_reply?.enabled && <div className="small-icon"><CiLocationArrow1 className="direct" /> DM Reply Enabled</div>}
                {data.auto_reply?.story_reply?.enabled && <div className="small-icon"><TbHistoryToggle className="story" /> Story Reply Enabled</div>}
                {data.auto_reply?.comment_reply?.enabled && <div className="small-icon"><AiOutlineComment className="comment" /> Comment Reply Enabled</div>}
            </div>
            {tagChild}
            <Button color="primary" variant="dashed" onClick={() => { setShowTriggerModal(true) }} className="flow-action-btn">Add new trigger</Button>

            <Drawer title="Trigger Configuration" style={{ width: "500px", backgroundColor: '#f5f5ff' }} placement="left" open={showTriggerModal} onClose={() => setShowTriggerModal(false)}>




                <div className="trigger-action-box">
                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                        <h4 style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center', gap: "10px" }}>
                            <CiLocationArrow1 className="icon direct" /> Audience DM message contains
                        </h4>
                        <Switch style={{ marginTop: '20px' }} onChange={(value) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, dm_reply: { ...data.auto_reply?.dm_reply, enabled: value } } }) }} value={data.auto_reply?.dm_reply?.enabled || false} />
                    </div>
                    {
                        data.auto_reply?.dm_reply.enabled &&

                        <div style={{ marginTop: "40px" }}>
                            <p>
                                <ThunderboltOutlined className="icon thunder" /> Trigger : When an audience  DM'ed you.
                            </p>
                            <div className="flex-divider">

                                <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, dm_reply: { ...data.auto_reply?.dm_reply, automate_all: e.target.value } } }) }} value={data.auto_reply?.dm_reply?.automate_all || "false"}>
                                    <Radio.Button value="false">Custom Word</Radio.Button>
                                    <Radio.Button value="true">All Message</Radio.Button>
                                </Radio.Group>

                                {data.auto_reply?.dm_reply?.automate_all != "true" ?
                                    isAddingTag && addingType === 'dm_reply' ? (
                                        <Input
                                            placeholder="Expected Word"
                                            ref={inputRef}
                                            type="text"
                                            size="large"
                                            style={{ width: '200px' }}
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            onBlur={handleInputConfirm}
                                            onPressEnter={handleInputConfirm}
                                        />
                                    ) : (
                                        <>
                                            <Tag className="add-new-tag" onClick={() => showInput('dm_reply')}>
                                                <PlusOutlined /> Expected Word
                                            </Tag>


                                        </>
                                    )
                                    : <p>All DM's will be automated.</p>

                                }

                                {data.auto_reply?.dm_reply.automate_all != "true" && <div>{data.auto_reply?.dm_reply?.triger_words?.map((tag) => renderItem(tag, 'dm_reply'))}</div>}
                                
                                {data.auto_reply?.dm_reply.automate_all == "true" && 
                                    <div style={{marginTop:"-30px"}}>    
                                        <p>Select Interval</p>
                                        <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, dm_reply: { ...data.auto_reply?.dm_reply, one_time_only: e.target.value } } }) }} value={data.auto_reply?.dm_reply?.one_time_only}>
                                            <Radio.Button value={true}>For the first time</Radio.Button>
                                            <Radio.Button value={false}>Once in a Day</Radio.Button>
                                        </Radio.Group>
                                        {
                                            data.auto_reply?.dm_reply?.one_time_only ? <p>Your contacts will receive this flow automation only for the first time.</p> :<p>Your contacts will receive this flow automation once in a day, when start a conversation.</p>
                                        }
                                        <Tooltip title="Replying to every incoming message with global DM automation may frustrate contacts, as it limits meaningful conversations. Restricting replies to once per day or only on the first message can improve the experience." placement="bottom">
                                        <p style={{cursor:"pointer", width:"100px"}}>What is this?</p>
                                        </Tooltip>
                                    </div>
                                }


                            </div>
                        </div>
                    }
                </div>

                <div className="trigger-action-box">
                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                        <h4 style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center', gap: "10px" }}>
                            <TbHistoryToggle className="icon story" /> Audience Story replies contains
                        </h4>
                        <Switch style={{ marginTop: '20px' }} onChange={(value) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, story_reply: { ...data.auto_reply?.story_reply, enabled: value } } }) }} value={data.auto_reply?.story_reply?.enabled || false} />
                    </div>

                    {
                        data.auto_reply?.story_reply.enabled &&
                        <>

                            <div style={{ marginTop: "40px" }}>
                                <p>
                                    <GrMultiple className="icon" /> Step 1: Select the stories.
                                </p>
                                <div className="flex-divider">

                                    <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, story_reply: { ...data.auto_reply?.story_reply, all_stories: e.target.value } } }) }} value={data.auto_reply?.story_reply?.all_stories || "false"}>
                                        <Radio.Button value="false">Select Stories</Radio.Button>
                                        <Radio.Button value="true">Any Stories</Radio.Button>
                                    </Radio.Group>

                                    {data.auto_reply?.story_reply?.all_stories != "true" ?
                                        <div > 
                                            {/* style={{display:"flex", flexDirection:"row"}}> */}
                                            <RenderPosts postList={storiesList} SelectedList={data.auto_reply?.story_reply.selected_posts || []} SetSelected={(post) => {
                                                
                                                console.log("Post clicked", post)
                                                if (data.auto_reply?.story_reply.selected_posts == undefined){
                                                    updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, story_reply: {...data.auto_reply?.story_reply, selected_posts:[post.id]}}} )
                                                    return
                                                }
                                                if (data.auto_reply?.story_reply.selected_posts.includes(post.id)) {
                                                    let selected_posts = data.auto_reply?.story_reply.selected_posts.filter(id => id !== post.id);
                                                    updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, story_reply: {...data.auto_reply?.story_reply, selected_posts:[...selected_posts]}}} )
                                                    return
                                                } else {
                                                    updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, story_reply: {...data.auto_reply?.story_reply, selected_posts:[...data.auto_reply?.story_reply.selected_posts, post.id]}}} )
                                                    return
                                                }
                                            }} setLoadMore={loadMoreStories} loading={loadingStories} />
                                            {/* <Button block style={{marginTop:"10px"}}>Load More Posts</Button> */}
                                        </div>
                                        : <p>Any Stories, current stories and future stories will be automated.</p>

                                    }


                                </div>
                            </div>

                            <div style={{ marginTop: "40px" }}>
                                <p>
                                    <ThunderboltOutlined className="icon thunder" /> Step 2 : Trigger Word.
                                </p>
                                <div className="flex-divider">

                                    <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, story_reply: { ...data.auto_reply?.story_reply, automate_all: e.target.value } } }) }} value={data.auto_reply?.story_reply?.automate_all || "false"}>
                                        <Radio.Button value="false">Custom Word</Radio.Button>
                                        <Radio.Button value="true">All Message</Radio.Button>
                                    </Radio.Group>

                                    {data.auto_reply?.story_reply?.automate_all != "true" ?
                                        isAddingTag && addingType === 'story_reply' ? (
                                            <Input
                                                placeholder="Expected Word"
                                                ref={inputRef}
                                                type="text"
                                                size="large"
                                                style={{ width: '200px' }}
                                                value={inputValue}
                                                onChange={handleInputChange}
                                                onBlur={handleInputConfirm}
                                                onPressEnter={handleInputConfirm}
                                            />
                                        ) : (
                                            <>
                                                <Tag className="add-new-tag" onClick={() => showInput('story_reply')}>
                                                    <PlusOutlined /> Expected Word
                                                </Tag>


                                            </>
                                        )
                                        : <p>All DM's will be automated.</p>

                                    }

                                    {data.auto_reply?.story_reply.automate_all != "true" && <div>{data.auto_reply?.story_reply?.triger_words?.map((tag) => renderItem(tag, 'story_reply'))}</div>}



                                </div>
                            </div>
                        </>
                    }



                </div>

                <div className="trigger-action-box">
                    <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                        <h4 style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center', gap: "10px" }}>
                            <AiOutlineComment className="icon comment" /> Reels or Posts comment contains
                        </h4>
                        <Switch style={{ marginTop: '20px' }} onChange={(value) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply: { ...data.auto_reply.comment_reply, enabled: value } } }) }} value={data.auto_reply?.comment_reply?.enabled || false} />
                    </div>
                { 
                    data.auto_reply.comment_reply.enabled &&
                    <>
                    <div style={{ marginTop: "40px" }}>
                        <p>
                            <GrMultiple className="icon" /> Step 1: Select the Posts.
                        </p>
                        <div className="flex-divider">

                            <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply: { ...data.auto_reply.comment_reply, all_posts: e.target.value } } }) }} value={data.auto_reply?.comment_reply?.all_posts || "false"}>
                                <Radio.Button value="false">Select Posts</Radio.Button>
                                <Radio.Button value="false-ads">Select Meta Ad's</Radio.Button>
                                <Radio.Button value="true">Any Posts & Ad's</Radio.Button>
                            </Radio.Group>


                        </div>
                    </div>

                    { 
                         data.auto_reply?.comment_reply?.all_posts != "true" &&
                        <div style={{marginTop:"20px"}}> 

                        {(data.auto_reply.comment_reply.selected_posts || []).length >0  && <p> {(data.auto_reply.comment_reply.selected_posts || []).length} Post selected</p> }
                            
                            {
                                data.auto_reply?.comment_reply?.all_posts == "false-ads" &&
                                <div>
                                     <RenderAds postList={AdsList} SelectedList={data.auto_reply.comment_reply.selected_posts || []} SetSelected={(post) => {
                                        console.log("-=-=-SELECTED POSTS=-=-", data.auto_reply.comment_reply.selected_posts , post)
                                        if (data.auto_reply.comment_reply.selected_posts == undefined){
                                            updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, comment_reply: {...data.auto_reply.comment_reply, selected_posts:[post.id]}}} )
                                            return
                                        }
                                        if (data.auto_reply.comment_reply.selected_posts.includes(post.id)) {
                                            let selected_posts = data.auto_reply.comment_reply.selected_posts.filter(id => id !== post.id);
                                            updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, comment_reply: {...data.auto_reply.comment_reply, selected_posts:[...selected_posts]}}} )
                                            return
                                        } else {
                                            updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, comment_reply: {...data.auto_reply.comment_reply, selected_posts:[...data.auto_reply.comment_reply.selected_posts, post.id]}}} )
                                            return
                                        }
                                    }} setLoadMore={setLoadMoreAds} loading={loadingAds} setAdsList={setAdsList} >

                                </RenderAds>
                            <Button block style={{marginTop:"10px"}} onClick={() => setLoadMoreAds(true)}>Load More Ads</Button>

                                </div>
                            }
                            
                            {data.auto_reply?.comment_reply?.all_posts != "false-ads" && <div><RenderPosts postList={postList} SelectedList={data.auto_reply.comment_reply.selected_posts || []} SetSelected={(post) => {
                                        if (data.auto_reply.comment_reply.selected_posts == undefined){
                                            updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, comment_reply: {...data.auto_reply.comment_reply, selected_posts:[post.id]}}} )
                                            return
                                        }
                                        if (data.auto_reply.comment_reply.selected_posts.includes(post.id)) {
                                            let selected_posts = data.auto_reply.comment_reply.selected_posts.filter(id => id !== post.id);
                                            updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, comment_reply: {...data.auto_reply.comment_reply, selected_posts:[...selected_posts]}}} )
                                            return
                                        } else {
                                            updateNodeData(id, { ...data, auto_reply: {...data.auto_reply, comment_reply: {...data.auto_reply.comment_reply, selected_posts:[...data.auto_reply.comment_reply.selected_posts, post.id]}}} )
                                            return
                                        }
                                    }} setLoadMore={data.auto_reply?.comment_reply?.all_posts == "false-ads" ? loadMoreAds : loadMorePosts} loading={data.auto_reply?.comment_reply?.all_posts == "false-ads" ? loadingAds : loadingPosts} />
                            <Button block style={{marginTop:"10px"}} onClick={() => setLoadMorePosts(true)}>Load More Posts</Button>
                        </div>
}    
                        </div>
                    }


                        <div style={{ marginTop: "40px" }}>
                            <p>
                                <ThunderboltOutlined className="icon thunder" /> Step 2 : Trigger Word.
                            </p>
                            <div className="flex-divider">

                                <Radio.Group onChange={(e) => { updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply: { ...data.auto_reply.comment_reply, automate_all: e.target.value } } }) }} value={data.auto_reply?.comment_reply?.automate_all || "false"}>
                                    <Radio.Button value="false">Custom Word</Radio.Button>
                                    <Radio.Button value="true">All Comment</Radio.Button>
                                </Radio.Group>

                                {data.auto_reply?.comment_reply?.automate_all != "true" ?
                                    isAddingTag && addingType === 'comment_reply' ? (
                                        <Input
                                            placeholder="Expected Word"
                                            ref={inputRef}
                                            type="text"
                                            size="large"
                                            style={{ width: '200px' }}
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            onBlur={handleInputConfirm}
                                            onPressEnter={handleInputConfirm}
                                        />
                                    ) : (
                                        <>
                                            <Tag className="add-new-tag" onClick={() => showInput('comment_reply')}>
                                                <PlusOutlined /> Expected Word
                                            </Tag>


                                        </>
                                    )
                                    : <p>All DM's will be automated.</p>

                                }

                                {data.auto_reply.comment_reply.automate_all != "true" && <div>{data.auto_reply.comment_reply?.triger_words?.map((tag) => renderItem(tag, 'comment_reply'))}</div>}

                            </div>
                        </div>


                        <div style={{ marginTop: "40px" }}>
                            <p>
                                <ThunderboltOutlined className="icon thunder" /> Step 3 : Welcome Message.
                            </p>
                            <div className="flex-divider">
                                <Input onChange={(e) => {
                                    updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, welcome_message:{...data.auto_reply.welcome_message , title: e.target.value }} })
                                }} value={data.auto_reply.welcome_message.title } placeholder="Thanks for commenting" />
                                
                                <Input.TextArea
                                placeholder ="Some description (Optional)"
                                onChange={(e) => {
                                    updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, welcome_message:{...data.auto_reply.welcome_message , description: e.target.value }} })
                                }} value={data.auto_reply.welcome_message.description} 
                                // rows={3}
                                autoSize={{ minRows:3 ,maxRows: 5 }}
                                 />
                                <Input
                                
                                onChange={(e) => {
                                    updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, welcome_message:{...data.auto_reply.welcome_message , button: e.target.value }} })
                                }} 
                                value={data.auto_reply.welcome_message.button} 
                                placeholder="Send me link (Button text)" />
                            </div>
                        </div>


                        <div style={{ marginTop: "40px" }}>
                            <p>
                                <ThunderboltOutlined className="icon thunder" /> Step 4 : Reply to comment.
                            </p>
                            <div className="flex-divider">

                                {
                                    isAddingTag && addingType === 'comment_response' ? (
                                        <Input
                                            placeholder="Expected Word"
                                            ref={inputRef}
                                            type="text"
                                            size="large"
                                            style={{ width: '200px' }}
                                            value={inputValue}
                                            onChange={handleInputChange}
                                            onBlur={handleInputConfirm}
                                            onPressEnter={handleInputConfirm}
                                        />
                                    ) : (
                                        <>
                                        <Tag className="add-new-tag" onClick={() => showInput('comment_response')}>
                                            <PlusOutlined /> Expected Word
                                        </Tag>
                                        </>
                                    )
                                    

                                }

                                {<div>{data.auto_reply.comment_reply.comment_response?.map((tag) => renderItem(tag, 'comment_response'))}</div>}

                            </div>
                            <Checkbox onChange={(e) => {
                                updateNodeData(id, { ...data, auto_reply: { ...data.auto_reply, comment_reply:{...data.auto_reply.comment_reply , include_ai_comment_reply: e.target.checked }} })
                
                            }} checked={data.auto_reply?.comment_reply?.include_ai_comment_reply}> Also Include AI Comment Reply (to prevent comment spam)</Checkbox>
                        </div>
                    {/* {
                        data.auto_reply.comment_reply.enabled && data.auto_reply?.comment_reply?.all_posts == "true" &&

                        <p>All Posts will be automated.</p>
                    } */}
                    </>
                }
                </div>

            </Drawer>
        </div>
    )

}

